import { BrandType, LanguageEnum } from '@/types';
import styles from './brand.module.scss';
import { PATH } from '@/data';
import { useContext } from 'react';
import { GlobalContext } from '@/context';
import { TbArrowNarrowLeft, TbArrowNarrowRight, TbWorld } from 'react-icons/tb';
import Link from 'next/link';
import Image from 'next/image';
import { FaStar } from 'react-icons/fa6';
import { RiDiscordFill, RiFacebookFill, RiInstagramFill, RiLinkedinFill, RiRedditFill, RiTelegramFill, RiTiktokFill, RiTwitterFill, RiWhatsappFill, RiYoutubeFill } from 'react-icons/ri';
import { Button } from 'antd';
export default function ServiceBrandInfo({
  brand
}: {
  brand: BrandType;
}) {
  const {
    langText
  } = useContext(GlobalContext);
  const lang = langText.brandInfo;
  const language = langText.lang;
  const socials = [{
    label: 'RedditF',
    link: brand.reddit,
    icon: RiRedditFill
  }, {
    label: 'Discord',
    link: brand.discord,
    icon: RiDiscordFill
  }, {
    label: 'TikTok',
    link: brand.tiktok,
    icon: RiTiktokFill
  }, {
    label: 'Linkedin',
    link: brand.linkedin,
    icon: RiLinkedinFill
  }, {
    label: 'Facebook',
    link: brand.facebook,
    icon: RiFacebookFill
  }, {
    label: 'Youtube',
    link: brand.youtube,
    icon: RiYoutubeFill
  }, {
    label: 'Twitter',
    link: brand.twitter,
    icon: RiTwitterFill
  }, {
    label: 'Instagram',
    link: brand.instagram,
    icon: RiInstagramFill
  }, {
    label: 'Whatsapp',
    link: brand.whatsapp,
    icon: RiWhatsappFill
  }, {
    label: 'Telegram',
    link: brand.telegram,
    icon: RiTelegramFill
  }, {
    label: 'TikTok',
    link: brand.website,
    icon: TbWorld
  }];
  return <div className={`flex-column gap-24 mb-10 ${styles['brand-info']}`} data-sentry-component="ServiceBrandInfo" data-sentry-source-file="brandInfo.index.tsx">
            <div className="justify-content-between">
                <div className="d-flex justify-content-center align-items-center gap-16">
                    <Link href={PATH(language).brand(brand.slug)} target="blank" data-sentry-element="Link" data-sentry-source-file="brandInfo.index.tsx">
                        {brand.main_image?.file.length && <Image src={brand.main_image.file} alt={brand.main_image.alt ?? 'service info'} width={50} height={50} />}
                    </Link>
                    <span>
                        <h2 className="t-p1 t-600 t-dark2">{brand.title}</h2>
                        <span className="d-flex gap-8 align-items-center">
                            <p className="t-p1 t-400 t-dark4">
                                <FaStar size={12} data-sentry-element="FaStar" data-sentry-source-file="brandInfo.index.tsx" /> {brand.average_stars?.toFixed(1)}
                            </p>
                            <p className="t-dark4 t-400 t-p2">
                                {brand.total_orders} {lang.sale}
                            </p>
                        </span>
                    </span>
                </div>
                <Link href={PATH(language).brand(brand.slug)} target="blank" className={`t-p1 t-600 t-dark2 ${styles['brand-view']}`} data-sentry-element="Link" data-sentry-source-file="brandInfo.index.tsx">
                    <Button type="text" data-sentry-element="Button" data-sentry-source-file="brandInfo.index.tsx">
                        <div className="t-primary align-items-center gap-8">
                            {lang.brandView}
                            {language === LanguageEnum.fa ? <TbArrowNarrowLeft size={20} /> : <TbArrowNarrowRight size={20} />}
                        </div>
                    </Button>
                </Link>
            </div>
            <div className={`t-dark2 ${brand.description ? '' : 'd-none'}`} dangerouslySetInnerHTML={{
      __html: brand.description
    }} />
            <div className={`gap-16 flex-pre-md-column ${styles['more-tools']}`}>
                <div className={`flex-1 pv-2 ph-3 ${!brand.phone ? 'd-none' : ''}`}>
                    <p className="t-p1 t-700 t-dark1 mb-2">{lang.contact_numbers}</p>
                    <ul className={`mv-0 ps-2 ${styles['phones']}`}>
                        {brand.phone?.length ? brand.phone.split('\r\n').map((phone: string, index: number) => <li key={index}>{phone}</li>) : null}
                        {brand.mobile?.length ? brand.mobile.split('\r\n').map((phone: string, index: number) => <li key={index}>{phone}</li>) : null}
                    </ul>
                </div>
                <div className={`flex-1 pv-2 ph-3 ${!brand.address ? 'd-none' : ''}`}>
                    <p className="t-p1 t-700 t-dark1 mb-2">{lang.address}</p>
                    <p style={{
          display: 'inline-block'
        }} className="t-400 t-p1 t-dark2 ltr-i">
                        {brand.address ?? ''}
                    </p>
                </div>
                <div className={`flex-1 pv-2 ph-3 ${socials.filter(i => i.link?.length).length ? '' : 'd-none'}`}>
                    <p className="t-700 t-p1 t-dark1 mb-2">{lang.social_networks}</p>
                    <span className="gap-16 flex-wrap">
                        {socials.map((item, index) => <a key={index} aria-label={item.label} target="_blank" className={`${!item.link?.length ? 'd-none' : ''}`} href={item.link ?? ''}>
                                <item.icon size={24} />
                            </a>)}
                    </span>
                </div>
            </div>
        </div>;
}